import moment from 'moment'
import config from 'config/config'
import { Buffer } from 'buffer'
import downloadjs from 'downloadjs'
import html2canvas from 'html2canvas'

export const makeURL = (API_VERSION) => {
  return `${config.baseUrl}${API_VERSION}`
}
export const makeClientId = () => {
  return `${config.azureInfo.clientId}`
}

export const makeMassGov = () => {
  return `${config.azureInfo.massGov}`
}

export const makeMassGovB2C = () => {
  return `${config.azureInfo.massGovB2C}`
}

export const makeMsauthRedirectURI = () => {
  return `${config.azureInfo.msauthRedirectURI}`
}

export const makesignInSignUpPolicy = () => {
  return `${config.azureInfo.signInSignUp}`
}

export const makepasswordResetPolicy = () => {
  return `${config.azureInfo.passwordReset}`
}
export function sliceIntoChunks (arr, i, chunkSize) {
  i = i - 1
  const index = i > 0 ? chunkSize * i : 0
  const chunk = arr.slice(index, index + chunkSize)
  return chunk
}

export function showCurrentPage (arr, i, chunkSize) {
  i = i - 1
  const index = i > 0 ? chunkSize * i : 0
  let currentPage = `${index + 1} - ${index + chunkSize}`

  if (index + chunkSize > arr.length) {
    currentPage = `${index + 1} - ${arr.length}`
  }
  return currentPage
}
export function dateEmptyCheck (val) {
  const empty = [null, ' ', '', '-', '--', undefined]
  return empty.indexOf(val) !== -1
}
export function formatDate (dateString) {
  const momentObj = moment(dateString, 'YYYY-MM-DD')
  return momentObj.format('DD.MMM.YYYY')
}

export function formatTime (timeString) {
  if (timeString && timeString !== '') {
    const [hours, minutes] = timeString && timeString?.split(':')
    let hrNum = parseInt(hours, 10)
    const ampm = hrNum >= 12 ? 'PM' : 'AM'
    hrNum = hrNum % 12 || 12
    const formattedHr = hrNum.toString().padStart(2, '0')
    return `${formattedHr}:${minutes} ${ampm}`
  }
  return ''
}

export function format24Time (timeString) {
  if (timeString && timeString !== '') {
    const [hours, minutes] = timeString && timeString?.split(':')
    return `${hours}:${minutes}`
  }
  return ''
}

export function addSecondsAndMilliSeconds (dateString) {
  return `${dateString}:00.000`
}

export const formatRenewalDays = (date) => {
  const renewDate = moment(date, 'YYYY-MM-DD')
  const currentDate = moment(new Date(), 'YYYY-MM-DD')
  return renewDate.diff(currentDate, 'days')
}

export const addOrRemoveDays = (days) => {
  const currentDate = moment(new Date(), 'MM/DD/YYYY')
  return moment(currentDate.add(days, 'days'), 'MM/DD/YYYY')
}

export function formatPhoneNumber (input) {
  if (!input || isNaN(input)) return '-'
  if (typeof (input) !== 'string') input = input.toString()
  if (input.length === 10) {
    return input.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
  } else if (input.length < 10) {
    return 'was not supplied enough numbers please pass a 10 digit number'
  } else if (input.length > 10) {
    return 'was supplied too many numbers please pass a 10 digit number'
  } else {
    return 'something went wrong'
  }
}

export function showPDFinWindow (data, webAppId) {
  // For IE using atob convert base64 encoded data to byte array
  if (data !== undefined) {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      const byteCharacters = Buffer.from(data, 'base64')
      const blob = new Blob([byteCharacters], {
        type: 'application/pdf'
      })
      window.navigator.msSaveOrOpenBlob(blob, webAppId + '.pdf')
    } else {
      const byteCharacters = Buffer.from(data, 'base64')
      const file = new Blob([byteCharacters], { type: 'application/pdf' })
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL)
    }
    // for Blob as Html page
  }
}

export function downloadPDF (data, name) {
  const today = new Date()
  const fileNameDate = today.toISOString().slice(0, 10).replace(/-/g, '')
  const byteCharacters = atob(data)
  const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0))
  const byteArray = new Uint8Array(byteNumbers)
  const blob = new Blob([byteArray], { type: 'application/pdf' })
  const blobURL = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = blobURL
  link.download = `${name}_${fileNameDate}.pdf`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(blobURL)
}

export const uniqueId = () => {
  const dateString = Date.now().toString(36)
  const randomness = Math.random().toString(36).slice(2)
  return dateString + '-' + randomness
}

export const handleCaptureClick = async ($dom, filename = 'myservices.png', format = 'image/png') => {
  const domElement =
    document.querySelector($dom)
  if (!domElement) return
  const canvas = await html2canvas(domElement)
  const dataURL = canvas.toDataURL(format)
  downloadjs(dataURL, filename, format)
}

export const getDecryptedValue = (encryptedString) => {
  if (encryptedString) {
    return Buffer.from(encryptedString, 'base64').toString('UTF-8')
  }
}

export const getEncryptedValue = (toEncryptString) => {
  if (toEncryptString) {
    return Buffer.from(toEncryptString, 'UTF-8').toString('base64')
  }
}
